
const ImageSection = () => {
  return (
    <div className="w-1/2 relative">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-blue-500 to-green-400">
        <div className="absolute top-8 left-8 text-white">
          <span className="text-sm font-medium text-blue-100">Bynry</span>
          <h1 className="text-3xl font-bold">SMART360</h1>
          <p className="text-sm">WHERE EFFICIENCY MEETS AFFORDABILITY</p>
        </div>
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <h2 className="text-xl font-semibold mb-2">
            Unified Utility Management
          </h2>
          <p className="text-sm leading-relaxed opacity-90">
            Smart way to manage utilities, orders, assets, and customer service.
          </p>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-80 h-80 rounded-full border-[40px] border-white/20 flex items-center justify-center">
            <div className="w-40 h-40 rounded-full bg-white/10"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSection;
